import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=50745872&scoped=true&"
import script from "./Sensor.vue?vue&type=script&lang=ts&"
export * from "./Sensor.vue?vue&type=script&lang=ts&"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=50745872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50745872",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
